import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
const beforeItems = ['Sin energía', 'Problemas digestivos', 'Pelo opaco', 'Baja vitalidad'];
const afterItems = ['Más energía', 'Mejor digestión', 'Pelo brillante', 'Mayor vitalidad y calidad de vida'];
export function BeforeAfterSection() {
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6 md:mb-8" data-id="element-23">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal font-serif leading-tight" data-id="element-24">
            La alimentación <span className="text-primary" data-id="element-25">lo cambia todo</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-3 items-start" data-id="element-26">
          {/* ANTES Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-red-50 rounded-2xl overflow-hidden border border-red-100" data-id="element-27">
            {/* Label */}
            <div className="px-4 pt-3 pb-2" data-id="element-28">
              <span className="inline-block px-3 py-1 bg-red-500 text-white text-xs font-extrabold uppercase tracking-wider rounded-full" data-id="element-29">
                Antes
              </span>
            </div>

            {/* Image */}
            <div className="w-full px-3 pb-2" data-id="element-30">
              <img src="https://cdn.magicpatterns.com/uploads/q2T9NkuRBnPMy3Sqjt9iaH/IMG_4295.png" alt="Antes - perro sin energía con alimento procesado" className="w-full object-contain rounded-xl" data-id="element-31" />
            </div>

            {/* List */}
            <div className="px-4 py-3" data-id="element-32">
              <ul className="space-y-1.5" data-id="element-33">
                {beforeItems.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-34">
                    <XCircleIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-35" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-36">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Arrow Divider */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.2
        }} className="flex justify-center items-center py-1 md:py-0 md:self-center" data-id="element-37">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center shadow-lg" data-id="element-38">
              {/* Down arrow on mobile, right arrow on desktop */}
              <svg className="w-5 h-5 text-white md:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-39">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-40" />
              </svg>
              <ArrowRightIcon className="w-5 h-5 text-white hidden md:block" data-id="element-41" />
            </div>
          </motion.div>

          {/* DESPUÉS Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="bg-green-50 rounded-2xl overflow-hidden border border-green-200" data-id="element-42">
            {/* Label */}
            <div className="px-4 pt-3 pb-1" data-id="element-43">
              <span className="inline-block px-3 py-1 bg-primary text-white text-xs font-extrabold uppercase tracking-wider rounded-full" data-id="element-44">
                Después
              </span>
            </div>

            {/* Image */}
            <div className="w-full px-2" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/ttedP14LRB7P7Bx4hUSxvZ/x.png" alt="Después - perro feliz y activo con comida natural" className="w-full max-h-[200px] md:max-h-[240px] object-contain" data-id="element-46" />
            </div>

            {/* List */}
            <div className="px-4 py-3" data-id="element-47">
              <ul className="space-y-1.5" data-id="element-48">
                {afterItems.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-49">
                    <CheckCircle2Icon className="w-4 h-4 text-primary flex-shrink-0" data-id="element-50" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-51">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}